import { backendApi } from "../dynamicBAseQuery";

export const AuditLogApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        auditLogList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `auditLogList`,
                body: {...args}
            })
        }),

        logDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `logDropDown`,
            })
        }),
    })
})

export const {
    useAuditLogListMutation,
    useLogDropDownQuery,
}=AuditLogApi